// extracted by mini-css-extract-plugin
export var displayNone = "_q8-6";
export var imgContainer = "_q8-2";
export var overflowHidden = "_q8-3";
export var productInfoCardButtonContainer = "_q8-5";
export var productTitleText = "_q8-4";
export var rightArrow = "_q8-1";
export var rightArrowContainer = "_q8-0";